module.exports = __webpack_public_path__ + "media/images/countryrect/gn-846dd7780ed5372a6cf240cb4df99824.svg";